import { GuardedComponent } from '../components/guarded-component';
import { InvoiceReportPage } from '../features/invoice-report/invoice-report.page';

import { UserPermissionName } from '../models/user-permission-name';

export const InvoiceReportRoute = {
  path: '/invoice-reports',
  name: 'invoice Reports',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_INVOICE_REPORTS]} showPermissionError>
          <InvoiceReportPage />
        </GuardedComponent>
      ),
    },
  ],
};
